import { GlobalStyles } from "@mui/material";
import { scrollbarStyle } from "../styles";

const GlobalScrollbarStyles = () => <GlobalStyles styles={scrollbarStyle} />;

export default GlobalScrollbarStyles;
